import React from 'react'
import { IconButton, Tooltip, Fade, Typography } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { useZustand } from '../../hooks/useZustand'

const selectorDoNotSaveGraph = state => state.doNotSaveGraph

const AddNewStatementButton = ({ open, onOpen, onEnd }) => {
    const doNotSaveGraph = useZustand(selectorDoNotSaveGraph)

    // Don't render the button in private mode
    if (doNotSaveGraph) {
        return null
    }

    return (
        <Fade in={open} timeout={150} onExited={onEnd}>
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '48px',
                }}
            >
                <Typography
                    onClick={onOpen}
                    color="#6688ff"
                    variant="body1"
                    sx={{ cursor: 'pointer' }}
                >
                    add statement
                </Typography>
                <IconButton
                    onClick={onOpen}
                    style={{
                        color: '#6688ff',
                    }}
                >
                    <Tooltip title="Add New Statement">
                        <AddCircleIcon />
                    </Tooltip>
                </IconButton>
            </div>
        </Fade>
    )
}

export default AddNewStatementButton
